import { useState, useEffect } from 'react'
import { actualizacionesService, solicitudesMantenimientoService } from '../services/api'
import { IconUserEdit, IconTool, IconCheck } from '@tabler/icons-react'

export default function Solicitudes() {
  const [tab, setTab] = useState('datos')
  const [actualizaciones, setActualizaciones] = useState([])
  const [mantenimientos, setMantenimientos] = useState([])
  const [loading, setLoading] = useState(true)
  const [procesando, setProcesando] = useState(null)
  const [idSapPorSolicitud, setIdSapPorSolicitud] = useState({})

  useEffect(() => { cargar() }, [tab])

  const cargar = async () => {
    setLoading(true)
    try {
      if (tab === 'datos') {
        const res = await actualizacionesService.listar({ estado: 'pendiente' })
        setActualizaciones(res.data || [])
      } else {
        const res = await solicitudesMantenimientoService.listar({ estado: 'nueva' })
        setMantenimientos(res.data || [])
      }
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  const confirmarActualizacion = async (id) => {
    if (!window.confirm('¿Confirmar y aplicar estos cambios al residente? Esto también sincroniza con TOKU.')) return
    setProcesando(id)
    try {
      const nuevoIdSap = idSapPorSolicitud[id] || undefined
      await actualizacionesService.confirmar(id, { nuevoIdSap })
      cargar()
    } catch (err) {
      alert('Error al confirmar: ' + (err.response?.data?.error || err.message))
    } finally {
      setProcesando(null)
    }
  }

  const marcarContactado = async (id) => {
    setProcesando(id)
    try {
      await solicitudesMantenimientoService.actualizar(id, { estado: 'contactado' })
      cargar()
    } catch (err) {
      alert('Error: ' + (err.response?.data?.error || err.message))
    } finally {
      setProcesando(null)
    }
  }

  const timeAgo = (date) => {
    const diff = Date.now() - new Date(date)
    const h = Math.floor(diff / 3600000)
    if (h < 1) return 'hace unos minutos'
    if (h < 24) return `hace ${h}h`
    return `hace ${Math.floor(h/24)}d`
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <button
          className={`btn ${tab === 'datos' ? 'btn-primary' : ''}`}
          onClick={() => setTab('datos')}
          style={{ display: 'flex', alignItems: 'center', gap: 6 }}
        >
          <IconUserEdit size={15} /> Actualización de datos
        </button>
        <button
          className={`btn ${tab === 'mantenimiento' ? 'btn-primary' : ''}`}
          onClick={() => setTab('mantenimiento')}
          style={{ display: 'flex', alignItems: 'center', gap: 6 }}
        >
          <IconTool size={15} /> Mantenimiento
        </button>
      </div>

      {loading && <div style={{ padding: 24, textAlign: 'center', color: '#8A8A7A' }}>Cargando...</div>}

      {!loading && tab === 'datos' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {actualizaciones.length === 0 && (
            <div className="card" style={{ padding: 24, textAlign: 'center', color: '#8A8A7A' }}>
              No hay solicitudes de actualización de datos pendientes.
            </div>
          )}
          {actualizaciones.map(a => (
            <div key={a.id} className="card" style={{ padding: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                <div>
                  <div style={{ fontWeight: 500, fontSize: 14 }}>{a.locatario?.nombre}</div>
                  <div className="text-muted">{a.locatario?.subscriptionExternalId} · Ticket #{a.ticketId}</div>
                </div>
                <span style={{ fontSize: 11, color: '#8A8A7A' }}>{timeAgo(a.createdAt)}</span>
              </div>
              <div style={{ fontSize: 13, lineHeight: 1.8, marginBottom: 12 }}>
                {a.telefono && <div><strong>Teléfono:</strong> {a.telefono}</div>}
                {a.correoAlterno && <div><strong>Correo 1:</strong> {a.correoAlterno}</div>}
                {a.correoAlterno2 && <div><strong>Correo 2:</strong> {a.correoAlterno2}</div>}
                {a.correoAlterno3 && <div><strong>Correo 3:</strong> {a.correoAlterno3}</div>}
                {a.rfc && <div><strong>RFC:</strong> {a.rfc}</div>}
                {a.razonSocial && <div><strong>Razón social:</strong> {a.razonSocial}</div>}
                {a.direccionFacturacion && <div><strong>Dirección:</strong> {a.direccionFacturacion}</div>}
                {a.codigoPostal && <div><strong>Código postal fiscal:</strong> {a.codigoPostal}</div>}
                {a.regimenFiscalClave && <div><strong>Régimen fiscal:</strong> {a.regimenFiscalClave}</div>}
                {a.usoCfdi && <div><strong>Uso CFDI:</strong> {a.usoCfdi}</div>}
                {a.metodoPago && <div><strong>Método de pago:</strong> {a.metodoPago}</div>}
              </div>

              {(a.rfc || a.razonSocial || a.codigoPostal || a.regimenFiscalClave) && (
                <div className="form-group" style={{ marginBottom: 10 }}>
                  <label className="form-label" style={{ fontSize: 11 }}>
                    Nuevo ID SAP (opcional — solo si cambia el cliente en SAP Business One)
                  </label>
                  <input
                    className="form-input"
                    placeholder="Ej. C1915"
                    value={idSapPorSolicitud[a.id] || ''}
                    onChange={e => setIdSapPorSolicitud({ ...idSapPorSolicitud, [a.id]: e.target.value })}
                  />
                </div>
              )}

              <button
                className="btn btn-primary btn-sm"
                onClick={() => confirmarActualizacion(a.id)}
                disabled={procesando === a.id}
                style={{ display: 'flex', alignItems: 'center', gap: 6 }}
              >
                <IconCheck size={14} /> {procesando === a.id ? 'Aplicando...' : 'Confirmar y aplicar'}
              </button>
            </div>
          ))}
        </div>
      )}

      {!loading && tab === 'mantenimiento' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {mantenimientos.length === 0 && (
            <div className="card" style={{ padding: 24, textAlign: 'center', color: '#8A8A7A' }}>
              No hay solicitudes de mantenimiento nuevas.
            </div>
          )}
          {mantenimientos.map(m => (
            <div key={m.id} className="card" style={{ padding: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                <div>
                  <div style={{ fontWeight: 500, fontSize: 14 }}>{m.locatario?.nombre}</div>
                  <div className="text-muted">{m.locatario?.subscriptionExternalId} · Ticket #{m.ticketId}</div>
                </div>
                <span style={{ fontSize: 11, color: '#8A8A7A' }}>{timeAgo(m.createdAt)}</span>
              </div>
              <div style={{ fontSize: 13, lineHeight: 1.8, marginBottom: 12 }}>
                {m.numeroEquipos && <div><strong>Número de equipos:</strong> {m.numeroEquipos}</div>}
                {m.ubicaciones && <div><strong>Ubicaciones:</strong> {m.ubicaciones}</div>}
                {m.marcaModelo && <div><strong>Marca/modelo:</strong> {m.marcaModelo}</div>}
                {m.antiguedad && <div><strong>Antigüedad:</strong> {m.antiguedad}</div>}
                {m.tipoServicio && <div><strong>Tipo de servicio:</strong> {m.tipoServicio}</div>}
                <div><strong>¿Tiene registro previo?</strong> {m.tieneRegistro ? 'Sí' : 'No'}</div>
                {m.notas && <div><strong>Notas:</strong> {m.notas}</div>}
              </div>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => marcarContactado(m.id)}
                disabled={procesando === m.id}
                style={{ display: 'flex', alignItems: 'center', gap: 6 }}
              >
                <IconCheck size={14} /> {procesando === m.id ? 'Guardando...' : 'Marcar como contactado'}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
